module.exports = __webpack_public_path__ + "img/reset-password-icon.7e814188.svg";